<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">武侠管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>锁仓记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-select
          v-model="filter.leagueId"
          @change="getRecordList"
          placeholder="门派"
        >
          <el-option
            v-for="item in leagueList"
            :key="item.id"
            :label="item.name && item.name.zh"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-model="filter.type"
          @change="changeType"
          placeholder="类型"
        >
          <el-option label="锁仓和解锁" value></el-option>
          <el-option label="锁仓" :value="0"></el-option>
          <el-option label="解锁" :value="1"></el-option>
        </el-select>
        <el-select
          v-if="filter.type !== 1"
          v-model="filter.status"
          @change="changeStatus"
          placeholder="状态"
        >
          <el-option label="所有状态" value></el-option>
          <el-option label="锁仓中" :value="0"></el-option>
          <el-option label="已解锁" :value="1"></el-option>
        </el-select>
        <el-input
          placeholder="请输入锁仓ID"
          clearable
          v-model="filter.id"
        ></el-input>
        <el-input
          placeholder="请输入用户ID"
          clearable
          v-model="filter.userId"
        ></el-input>
        <el-button @click="getRecordList" type="primary">搜索</el-button>
      </div>
      <el-table :data="list">
        <el-table-column prop="id" label="ID" width="60"></el-table-column>
        <el-table-column
          prop="amount"
          label="数量"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="leagueId"
          label="门派ID"
          width="100"
        ></el-table-column>
        <el-table-column prop="userId" label="用户ID"></el-table-column>
        <el-table-column prop="type" label="类型">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 0" type="success">锁仓</el-tag>
            <el-tag v-else type="danger">解锁</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="锁仓状态">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.type === 0 && scope.row.status === 0"
              type="success"
              >锁仓中</el-tag
            >
            <el-tag
              v-if="scope.row.type === 0 && scope.row.status === 1"
              type="danger"
              >已解锁</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="时间">
          <template slot-scope="scope">{{
            scope.row.createTime | moment
          }}</template>
        </el-table-column>
        <el-table-column prop="unlockTime" label="解锁时间">
          <template slot-scope="scope">
            <span
              v-if="
                (scope.row.type === 0 && scope.row.status === 1) ||
                  scope.row.type === 1
              "
              >{{ scope.row.unlockTime | moment }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="lastSettleTime" label="最近利息结算时间">
          <template slot-scope="scope">
            <div
              type="danger"
              v-if="scope.row.lastSettleTime !== scope.row.createTime"
            >
              {{ scope.row.lastSettleTime | moment }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="lastRewardSettleTime" label="最近奖励结算时间">
          <template slot-scope="scope">
            <div
              type="danger"
              v-if="scope.row.lastRewardSettleTime !== scope.row.createTime"
            >
              {{ scope.row.lastRewardSettleTime | moment }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="备注">
          <template slot-scope="scope">
            <el-tag
              type="danger"
              v-if="scope.row.type === 1 && scope.row.isOwner === 1"
              >掌门离开</el-tag
            >
            <el-tag
              type="success"
              v-if="scope.row.type === 0 && scope.row.isOwner === 1"
              >掌门创建/续费</el-tag
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="totalCount"
        @pageChanged="handleCurrentChange"
      ></pagination>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import Pagination from 'components/pagination';
export default {
  name: 'leagueMain',
  data() {
    return {
      filter: {
        leagueId: undefined,
        status: '',
        type: '',
        id: ''
      }
    };
  },
  watch: {
    $route(val, oldVal) {
      if (!oldVal) {
        return;
      }
      if (val.query.id != oldVal.query.id) {
        this.filter.id = this.$route.query.id;
      }
      this.getRecordList();
    }
  },
  components: {
    Pagination
  },
  computed: {
    ...mapState({
      leagueList: state => state.league.list
    }),
    ...mapState('leagueRecord', ['list', 'pagination', 'totalCount'])
  },
  methods: {
    ...mapActions('leagueRecord', ['getList']),
    changeType() {
      if (this.type !== 0) {
        this.filter.status = '';
      }
      this.getRecordList();
    },
    changeStatus() {
      if (this.status !== '') {
        this.filter.type = 0;
      }
      this.getRecordList();
    },
    getRecordList(data = {}) {
      this.getList({ ...this.pagination, ...this.filter, ...data });
    },
    handleCurrentChange(pagination) {
      this.getRecordList(pagination);
    }
  },
  mounted() {
    this.$store.dispatch('league/getList');
    if (this.$route.query.leagueId) {
      this.filter.leagueId = +this.$route.query.leagueId;
      this.filter.type = 0;
      this.filter.status = 0;
    } else if (this.$route.query.id) {
      this.filter.id = this.$route.query.id;
    }
    this.getRecordList();
  }
};
</script>
<style lang="less" scoped>
.change {
  ::v-deep .el-button {
    margin-left: 20px;
  }
}
</style>
